// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_PlayerPage__3Exp6{
    width: 100%;
    overflow: auto;
    align-items: center;
}
.styles_ListContainer__Qh8bh{
    min-width: min-content;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
}
.styles_ControlPanel__MIdCN{
    padding: 20px;;
    display: flex;
    justify-content: start;
}

.styles_ControlPanel__MIdCN > *{
     margin-left: 20px;
}

.styles_TableContainer__Vdxo6 {
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.styles_TableContainer__Vdxo6 > * {
    max-width: 1200px;
}
.styles_DataGrid__05XDU{
    min-width: 70vmax;
}`, "",{"version":3,"sources":["webpack://./src/pages/OperatoresListPage/styles.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;KACK,iBAAiB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB","sourcesContent":[".PlayerPage{\n    width: 100%;\n    overflow: auto;\n    align-items: center;\n}\n.ListContainer{\n    min-width: min-content;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: center;\n}\n.ControlPanel{\n    padding: 20px;;\n    display: flex;\n    justify-content: start;\n}\n\n.ControlPanel > *{\n     margin-left: 20px;\n}\n\n.TableContainer {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.TableContainer > * {\n    max-width: 1200px;\n}\n.DataGrid{\n    min-width: 70vmax;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PlayerPage": `styles_PlayerPage__3Exp6`,
	"ListContainer": `styles_ListContainer__Qh8bh`,
	"ControlPanel": `styles_ControlPanel__MIdCN`,
	"TableContainer": `styles_TableContainer__Vdxo6`,
	"DataGrid": `styles_DataGrid__05XDU`
};
export default ___CSS_LOADER_EXPORT___;
